module.exports = __webpack_public_path__ + "img/expostyle_9213_yellow_pantone7406.64018a6d.jpg";